import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEO from '@/components/base/SEO';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedSection from './components/FeaturedSection';
import FeaturesSection from './components/FeaturesSection';
import ArticleListSection from '@/pages/article/components/ArticleListSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const homeSchema = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'ASMR免费网页 - 在线免费收听ASMR助眠白噪音',
    description: 'ASMR免费网页为您提供海量ASMR音频在线免费收听，无需下载、无需注册，涵盖助眠、解压、专注等多种场景音频。',
    url: 'https://asmr-free.com/',
    inLanguage: 'zh-CN',
    isPartOf: {
      '@type': 'WebSite',
      name: 'ASMR免费网页',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://asmr-free.com/',
        },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'ASMR免费网页真的完全免费吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，我们承诺所有音频内容完全免费，无需注册、无需下载。您可以随时随地打开网页免费收听所有ASMR音频。',
        },
      },
      {
        '@type': 'Question',
        name: 'ASMR对睡眠真的有帮助吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '大量研究和用户反馈表明，ASMR音频可以有效降低心率、缓解焦虑情绪，帮助人们更快进入睡眠状态。',
        },
      },
      {
        '@type': 'Question',
        name: '可以在手机上使用吗？需要下载APP吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的网站完美适配手机、平板和电脑等各种设备。只需在手机浏览器中打开网页，即可在线收听所有ASMR音频，无需下载任何APP。',
        },
      },
      {
        '@type': 'Question',
        name: '有哪些类型的ASMR音频？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们提供六大类音频内容：助眠类、解压类、专注类、白噪音类、自然音类和冥想类，满足您不同场景的需求。',
        },
      },
    ],
  },
];

export default function Home() {
  return (
    <>
      <SEO schemaData={homeSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedSection />
        <FeaturesSection />
        <ArticleListSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}